import { Theme, useMediaQuery } from "@mui/material";
import { Fragment, useCallback } from "react";
import CoreCreateButton from "../../../../shared/components/core/CoreCreateButton";
import { 
    TextField,
    DatagridConfigurable, 
    List, 
    SearchInput, 
    useListContext, 
    TopToolbar, 
    FilterButton, 
    SortButton, 
    useGetResourceLabel, 
    DateInput 
} from "react-admin";
import MobileGrid from "./MobileGrid";
import { defaultSacopExporter } from "../../../../shared/utilities/sacopExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <CoreCreateButton permission="BACKOFFICE_VERIFICATION_EFFECTIVENESS_ACTION_C" />
        <SortButton fields={['dateRequestAction']} />
        <FilterButton />
        <SacopExportButton exporter={defaultSacopExporter} />
    </TopToolbar>
);

//TODO: agregar mas atributos para filtrar los registros.
const sectorFilters = [
    <SearchInput source="q" alwaysOn />,
    <DateInput source="dateRequestAction" />,
    // <BooleanInput source="active" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    // const { filterValues, setFilters, displayedFilters } = listContext;
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    return (
        <Fragment>
            {(!isXSmall ? (
                <MobileGrid  {...listContext} />
            ) : (
                <DatagridConfigurable rowClick="edit" >
                    <TextField source="dateRequestAction" />
                </DatagridConfigurable>)
            )
            }
        </Fragment>
    );
}

const VerificationEffectivenessList = () => {
    const getResourceLabel = useGetResourceLabel();
    return (<List
        // filterDefaultValues={ { active: true }}
        sort={{ field: 'dateRequestAction', order: 'DESC' }}
        perPage={25}
        filters={sectorFilters}
        actions={<ListActions />}
        exporter={defaultSacopExporter}
    >
        <TabbedDatagrid />
    </List>);
};

export default VerificationEffectivenessList;

